import { useEffect, useState } from 'react';

import shallow from 'zustand/shallow';
import { useDialog } from '../state';

export const useInternetStatus = () => {
  const [isOnline, setIsOnline] = useState(true);
  // const [isOnline, setIsOnline] = useState(checkIsBrowser() ? navigator.onLine : null);
  const setDialog = useDialog(s => s.setDialog, shallow);

  useEffect(() => {
    /**
     * When the status of the browser changes, set the state of the component to reflect the new
     * status.
     */
    const handleStatusChange = (): void => {
      setIsOnline(navigator.onLine);
    };

    /* Listening to the online status. */
    window.addEventListener('online', handleStatusChange);

    /* Listening to the offline status. */

    window.addEventListener('offline', handleStatusChange);

    /* Cleaning up the event listeners. */
    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, [isOnline]);

  useEffect(() => {
    setDialog({
      wrapper: !isOnline,
      isOfflineDialog: !isOnline,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline]);

  return {};
};
